import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import FormSectionHeader from './FormSectionHeader';

interface CategoryFieldsProps {
  formData: {
    development_stage: string;
    industry_type: string;
    status: string;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const CategoryFields: React.FC<CategoryFieldsProps> = ({ 
  formData, 
  setFormData 
}) => {
  const developmentStages = [
    'Idea', 
    'MVP', 
    'Development', 
    'Launch', 
    'Growth', 
    'Scale'
  ];
  
  const industryTypes = [
    'Technology',
    'E-commerce',
    'Finance',
    'Healthcare',
    'Education',
    'Entertainment',
    'Other'
  ];

  return (
    <div className="space-y-4">
      <FormSectionHeader 
        title="Business Category" 
        description="Categorize your business for better discovery" 
        required={true}
      />
      
      <div className="grid gap-4 md:grid-cols-3">
        <div>
          <Label htmlFor="development_stage">Development Stage</Label>
          <Select
            value={formData.development_stage}
            onValueChange={(value) => setFormData(prev => ({ ...prev, development_stage: value }))}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select stage" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="development">Development</SelectItem>
              <SelectItem value="operation">Operation</SelectItem>
              <SelectItem value="growth">Growth</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label htmlFor="industry_type">Industry Type</Label>
          <Select
            value={formData.industry_type}
            onValueChange={(value) => setFormData(prev => ({ ...prev, industry_type: value }))}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select industry" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="technology">Technology</SelectItem>
              <SelectItem value="healthcare">Healthcare</SelectItem>
              <SelectItem value="finance">Finance</SelectItem>
              <SelectItem value="education">Education</SelectItem>
              <SelectItem value="retail">Retail</SelectItem>
              <SelectItem value="manufacturing">Manufacturing</SelectItem>
              <SelectItem value="services">Services</SelectItem>
              <SelectItem value="other">Other</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label htmlFor="status">Status</Label>
          <Select
            value={formData.status}
            onValueChange={(value) => setFormData(prev => ({ ...prev, status: value }))}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="draft">Draft</SelectItem>
              <SelectItem value="active">Active</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default CategoryFields;
